/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 图片列表底部组件
 * @LastEditors: yingongjing
 * @LastEditTime: 2025-12-11 11:00:00
 */

import React from 'react'
import { Button, Checkbox, Tooltip } from 'antd'
import './ImageListFooter.scss'

interface ImageListFooterProps {
  photosNum: number
  selectedCount: number
  checkAll: boolean
  selectedCountText: string
  isExtracting?: boolean // 是否正在提取水印
  onCheckAll: (e: any) => void
  onGoToAllPhotos: () => void
  onBatchDelete: () => void
}

const ImageListFooter: React.FC<ImageListFooterProps> = ({
  photosNum,
  selectedCount,
  checkAll,
  selectedCountText,
  isExtracting = false,
  onCheckAll,
  onGoToAllPhotos,
  onBatchDelete
}) => {
  return (
    <div className="footer">
      <div className="selectAllContainer">
        <div className="selectAllContent">
          <Checkbox
            disabled={photosNum === 0}
            indeterminate={
              (checkAll && selectedCount > 0 && selectedCount < photosNum) ||
              (!checkAll && selectedCount > 0 && selectedCount < photosNum)
            }
            checked={selectedCount === photosNum && photosNum > 0}
            onChange={onCheckAll}
          >
            全选
          </Checkbox>
          <span className="selectedInfo">
            已选择
            <strong className="selectedCount">{selectedCountText}</strong> 张
          </span>
        </div>
      </div>
      <div className="footer-bottom">
        <Tooltip
          title={isExtracting ? '正在提取水印，请稍候...' : ''}
          placement="top"
        >
          <Button
            type="primary"
            ghost
            onClick={onGoToAllPhotos}
            disabled={isExtracting}
          >
            继续添加照片
          </Button>
        </Tooltip>
        <Tooltip
          title={selectedCount === 0 ? '请先选择要移除的照片' : ''}
          placement="top"
        >
          <Button danger ghost onClick={onBatchDelete}>
            批量移除
          </Button>
        </Tooltip>
      </div>
    </div>
  )
}

export default ImageListFooter
